module.exports = __webpack_public_path__ + "assets/img/finish.cbf68f7d.png";